// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { blockTypePlugin } from '@atlaskit/editor-plugin-block-type';
export type {
	BlockTypePlugin,
	BlockTypePluginOptions,
	BlockType,
	BlockTypeState,
	InputMethod,
	ClearFormattingInputMethod,
	DropdownItem,
	TextBlockTypes,
} from '@atlaskit/editor-plugin-block-type';
